"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../type/entity");
function getILTProgressStatusFromCompletionStatus(state) {
    let progressStatus = entity_1.ILTProgressStatus.NOT_REGISTERED;
    switch (state.completionStatus) {
        case entity_1.CompletionStatus.COMPLETE:
            progressStatus = entity_1.ILTProgressStatus.COMPLETED;
            break;
        case entity_1.CompletionStatus.INCOMPLETE:
            progressStatus = entity_1.ILTProgressStatus.REGISTERED;
            break;
        case entity_1.CompletionStatus.NOT_ATTEMPTED:
            progressStatus = entity_1.ILTProgressStatus.NOT_REGISTERED;
            break;
        default:
            break;
    }
    return progressStatus;
}
exports.getILTProgressStatusFromCompletionStatus = getILTProgressStatusFromCompletionStatus;
//# sourceMappingURL=getILTProgressStatusFromCompletionStatus.js.map